import styled from '@emotion/styled';
import PropTypes from 'prop-types';

export const num = (n) => typeof n === 'number' && !isNaN(n);
export const px = (n) => (num(n) ? n + 'px' : n);
export const getWidth = (n) => (!num(n) || n > 1 ? px(n) : n * 100 + '%');
export const width = (props) => (props.width ? { width: getWidth(props.width) } : null);
export const minWidth = (props) => (props.minWidth ? { 'min-width': getWidth(props.minWidth) } : null);

const margin = (p) => {
    if (p.margin) {
        const name = p.margin === true ? 'extraSmall' : p.margin;
        return { margin: p.theme.size[name] };
    }
};
const padding = (p) => {
    if (p.padding) {
        const name = p.padding === true ? 'extraSmall' : p.padding;
        return { padding: p.theme.size[name] };
    }
};

export const Flex = styled.div`
    display: flex;
    flex: ${(p) => p.flex};
    align-items: ${(p) => p.alignItems};
    text-align: ${(p) => p.textAlign};
    align-self: ${(p) => p.alignSelf};
    justify-content: ${(p) => p.justifyContent};
    flex-flow: ${(p) => (p.column ? 'column' : null)} ${(p) => (p.wrapped ? 'wrap' : null)};
    flex-direction: ${(p) => (p.column ? 'column' : 'row')};
    ${margin}
    ${padding}
    ${width}
    ${minWidth}
`;

Flex.propTypes = {
    wrapped: PropTypes.bool,
    column: PropTypes.bool,
    justifyContent: PropTypes.string,
    alignItems: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
